<template>
  <div class="dashboard-editor-container" style="height: 100%;"/>
</template>

<script>
import pageComponent from '@/mixins/page-component';

export default {
  name: 'DashboardPage',
  mixins: [pageComponent],
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
}
</style>
